import Main from '@/views/administracion/estimaciones/Main.vue';
import Default from '@/views/administracion/estimaciones/Default.vue';
import MainContrato from '@/views/administracion/estimaciones/contrato/Main.vue';
import DefaultContrato from '@/views/administracion/contratos/contrato/Default.vue';
import MainAnticipos from '@/views/administracion/contratos/contrato/anticipos/Main.vue';
import MainEstimaciones from '@/views/administracion/ejecucion/contrato/estimaciones/Main.vue';
import DefaultEstimaciones from '@/views/administracion/ejecucion/contrato/estimaciones/Default.vue';
import MainCatalogo from '@/views/administracion/contratos/contrato/catalogo/Main.vue';
import MainPrograma from '@/views/administracion/contratos/contrato/programa/Main.vue';
import MainEscalatorias from '@/views/administracion/contratos/contrato/escalatorias/Main.vue';
import MainGastos from '@/views/administracion/contratos/contrato/gastos/Main.vue';
import MainConvenios from '@/views/administracion/contratos/contrato/convenios/Main.vue';
import MainExpediente from '@/views/administracion/estimaciones/contrato/expediente/Main.vue';
import MainEstadistcias from '@/views/administracion/estimaciones/estadisticas/Main.vue';

const auth = ['Estimaciones:ver'];
const scopes = ['Estimaciones:crear', 'Estimaciones:editar', 'Estimaciones:eliminar'];

const ejecucion = [
  {
    path: 'estimaciones',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'contratosEstimacionesEstadisticas',
        path: 'estadisticas',
        meta: {
          title: 'Estimaciones Estadisticas',
          auth,
          scopes,
        },
        component: MainEstadistcias,

        children: [],
      },
      {
        name: 'estimaciones',
        path: '/',
        meta: {
          title: 'Estimaciones',
          auth,
          scopes,
        },
        component: Default,
        children: [],
      },
      {
        path: ':idContrato',
        meta: {
          title: 'Contrato',
          auth,
          scopes,
        },
        component: MainContrato,
        children: [
          {
            path: 'estimaciones',
            meta: {
              title: 'Estimaciones',
              auth,
              scopes,
            },
            component: MainEstimaciones,
            children: [
              {
                name: 'contratoEstimaciones',
                path: '/',
                meta: {
                  title: 'Estimaciones',
                  auth,
                  scopes,
                },
                component: DefaultEstimaciones,
              },
              {
                name: 'contratoEstimacionesDefault',
                path: 'generales',
                meta: {
                  title: 'Generales',
                  auth,
                  scopes,
                },
                props: {
                  soloLectura: true,
                },
                component: DefaultContrato,
              },
              {
                name: 'contratoEstimacionesAnticipos',
                path: 'anticipos',
                meta: {
                  title: 'Anticipos',
                  auth,
                  scopes,
                },
                props: {
                  soloLectura: true,
                },
                component: MainAnticipos,
              },
              {
                name: 'contratoEstimacionesCatalogo',
                path: 'catalogo',
                meta: {
                  title: 'Catálogo',
                  auth,
                  scopes,
                },
                props: {
                  soloLectura: true,
                },
                component: MainCatalogo,
              },
              {
                name: 'contratoEstimacionesPrograma',
                path: 'programa',
                meta: {
                  title: 'Programa',
                  auth,
                  scopes,
                },
                props: {
                  soloLectura: true,
                },
                component: MainPrograma,
              },
              {
                name: 'contratoEstimacionesConveniosModificatorios',
                path: 'convenios',
                meta: {
                  title: 'Convenios modificatorios',
                  auth,
                  scopes,
                },
                props: {
                  soloLectura: true,
                },
                component: MainConvenios,
              },
              {
                name: 'constratoEstimacionesEscalatorias',
                path: 'escalatorias',
                meta: {
                  title: 'Escalatoorias',
                  auth,
                  scopes,
                },
                component: MainEscalatorias,
              },
              {
                name: 'constratoEstimacionesGastos',
                path: 'gastos',
                meta: {
                  title: 'Gastos',
                  auth,
                  scopes,
                },
                component: MainGastos,
              },
              {
                name: 'contratoEstimacionesExpediente',
                path: 'expediente',
                meta: {
                  title: 'Expediente',
                  auth,
                  scopes,
                },
                component: MainExpediente,
              },
            ],
          },
        ],
      },
    ],
  },
];

export default ejecucion;
